import mixpanel from 'mixpanel-browser'
import { logger } from '@moonpig/web-core-monitoring'

export const initMixpanel = (mixpanelRecordingPercent: number) => {
  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN

  if (!MIXPANEL_TOKEN) {
    logger.warning('Mixpanel token is missing! Check your .env file.')
    return
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    api_host: 'https://api-eu.mixpanel.com',
    autocapture: {
      pageview: false,
      click: true,
      capture_text_content: true,
      input: false,
      rage_click: false,
      submit: false,
      scroll: false,
    },
    track_pageview: 'full-url',
    record_sessions_percent: mixpanelRecordingPercent,
    record_mask_text_selector: '',
    record_block_selector: '',
  })
}

export const trackPageView = (url: string) => {
  mixpanel.track('Page View', { url })
}
